import { BookingStatus } from 'src/graphql/types/bookings'

export const isBookingCancelledOrNoShow = (status: BookingStatus) => {
  return [BookingStatus.CANCELLED, BookingStatus.NO_SHOW].includes(status)
}

export const bookingStatusToLabel = (status: BookingStatus) => {
  return status
    .split('_')
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ')
}
